import React from "react"
import PropTypes from "prop-types"
import {Button, Icon} from "elemental-react16"
import _ from "lodash"
import Dropzone from "react-dropzone"
import "./Form.scss"

export default class Attachments extends React.Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    accept:   PropTypes.string
  }

  constructor({onChange, accept = ".jpg,.jpeg,.png,.doc,.pdf"}) {
    super()
    this.state = {
      accept:         accept,
      files:          [],
      loading:        false,
      dropzoneActive: false
    }
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true
    })
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false
    })
  }

  onDrop(files) {
    files = _.uniq(files)
    // this.uploadFiles(files)
    this.props.onChange({files})
  }

  render() {
    const {accept, dropzoneActive} = this.state
    const overlayStyle             = {
      position:   "fixed",
      top:        0,
      right:      0,
      bottom:     0,
      left:       0,
      padding:    "2.5em 0",
      background: "rgba(0,0,0,0.5)",
      textAlign:  "center",
      color:      "#fff"
    }
    let {children}                 = this.props || <ButtonUpload/>
    let dropzoneRef
    let {loading}                  = this.state
    return (
      <Dropzone
        ref={(node) => {
          dropzoneRef = node
        }}
        disableClick
        style={{}}
        accept={accept}
        multiple={false}
        onDrop={this.onDrop.bind(this)}
        onDragEnter={this.onDragEnter.bind(this
        )}
        onDragLeave={this.onDragLeave.bind(this)}
      >
        { dropzoneActive && <div style={overlayStyle}>Drop files...</div> }
        <div
          onClick={() => {
            dropzoneRef.open()
          }}
        >{(loading) ? <Button
          basic
          loading
          color="green"
        ><Icon name="upload"/> Anhänge hinzufügen</Button> : children}</div>
      </Dropzone>
    )
  }
}


const ButtonUpload = () => <Button
  content={this.state.accept}
  icon="upload"
  label={{as: "a", basic: true, pointing: "right", content: "hochladen"}}
  labelPosition="left"
  basic
  color="grey"
/>



// WEBPACK FOOTER //
// ./src/components/Attachments/Attachments.js